import Axios from 'axios';

Axios.defaults.baseURL = 'https://api.reviewcardmaker.com/api';

export const axiosInstance = Axios.create({});
